<template>
	<div>
		<BaseAccordionController
			v-if="showList && dataloaded"
			:accordion_header="getStateWithParam('donations_label')"
			><template v-slot:component>
				<v-flex>
					<v-text-field
						v-model="donationSearch"
						:label="getStateWithParam('search')"
						clearable
						hide-details
						class="search-field mx-4"
					></v-text-field>
				</v-flex>
				<v-container class="card-wrapper" grid-list-lg>
					<v-layout class="card-inner-wrapper" row wrap>
						<Card
							v-for="donation in filteredDonationsList"
							:key="donation.id"
							:card_element="donation"
							class="card-item"
							@click.native="goToDonationsDetails(donation.id)"
						/>
					</v-layout>
				</v-container>
			</template> </BaseAccordionController
		><DonationsDetails
			v-if="showDetails || showForm"
			:showdetailsdialog="showDetails"
			:donationId="donationId"
		></DonationsDetails>
	</div>
</template>

<script>
import { API_CLIENT_GET } from "@/config/api/api_call/service_instances";
import { DONATIONS_LIST_URL } from "@/config/api/url/urls_in_app";

import Card from "./donations-card.vue";

import DonationsDetails from "../Donations-details/DonationsDetails.vue";

export default {
	props: {},
	components: { Card, DonationsDetails },
	data() {
		return {
			dataloaded: false,
			errorloading: false,
			donationsList: [],
			donationSearch: "",
		};
	},
	watch: {
		$route(to, from) {
			if (to.name == "donation_label" || from.name == "donationdetails") {
				this.$store.state.active_loader = false;
			}
		},
	},
	created() {
		this.getList();
	},
	computed: {
		showList() {
			return this.$route.name === "donationsmodule_label";
		},
		showDetails() {
			return this.$route.name === "donationdetails";
		},

		showForm() {
			return this.$route.name === "donationform";
		},

		donationId() {
			return this.$route.params.id;
		},

		filteredDonationsList() {
			let list = [...this.donationsList];
			if (this.donationSearch && this.donationSearch.length > 2) {
				list = list.filter(
					(donation) =>
						donation.name &&
						donation.name
							.toLowerCase()
							.includes(this.donationSearch.toLowerCase())
				);
			}
			return list;
		},
	},
	methods: {
		getList() {
			API_CLIENT_GET(DONATIONS_LIST_URL)
				.then((response) => {
					this.donationsList = response.data;
					this.dataloaded = true;
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		goToDonationsDetails(donationid) {
			this.$router.push({
				name: "donationdetails",
				params: { id: donationid },
			});
		},
		clearSearch() {
			this.donationSearch = "";
		},
	},
};
</script>

<style lang="scss" scoped>
.card-wrapper {
	position: relative;
	max-width: 100%;
	.card-inner-wrapper {
		z-index: 3;
		position: relative;
		margin: -8px auto !important;
		@media only screen and (min-width: 960px) {
			max-width: 900px;
		}
	}
}
.card-item {
	width: 50%;
}

.search-field {
	padding-left: 5px;
	padding-right: 5px;
	padding-top: 0;
}
</style>
